(function () {
  "use strict";
  angular
    .module("com.vmware.platform.ui")
    .service("featureFlagsService", featureFlagsService);

  featureFlagsService.$inject = ["configurationService"];

  function featureFlagsService(configurationService) {
    var self = {};

    fetchFeatureFlag("h5uiVmLibraryActionAddFlag");
    fetchFeatureFlag("h5uiDirectIsoMountFromCL");
    fetchFeatureFlag("h5uiAddNetworkingBindToPnic");
    fetchFeatureFlag("ARCTIC_H5C");
    fetchFeatureFlag("h5uiNRP");
    fetchFeatureFlag("h5uiSmartSearch");
    fetchFeatureFlag("VMcrypt_OnlineVMEncryption");
    fetchFeatureFlag("PMem");
    fetchFeatureFlag("PMemHA_V1");
    fetchFeatureFlag("h5uiCreateClusterMigration");
    fetchFeatureFlag("h5uiNgMigrationVmClone");
    fetchFeatureFlag("h5uiNgMigrationVmTemplateClone");
    fetchFeatureFlag("h5uiNgMigrationTemplateToTemplateClone");
    fetchFeatureFlag("h5uiNgMigrationVmCreate");
    fetchFeatureFlag("h5uiQuerySearch");
    fetchFeatureFlag("h5uiClientConfig");
    fetchFeatureFlag("h5uiNgMigrationAddNetworking");
    fetchFeatureFlag("h5uiNgMigrationVmEdit");
    fetchFeatureFlag("h5uiNgMigrationStorageProviders");
    fetchFeatureFlag("smartnic_network");
    fetchFeatureFlag("VirtualTopo");

    function fetchFeatureFlag(flagName) {
      self[flagName + "Enabled"] = function () {
        return false;
      };

      configurationService
        .isFeatureEnabled(flagName)
        .then(function (featureIsEnabled) {
          self[flagName + "Enabled"] = function () {
            return featureIsEnabled;
          };
        });
    }

    return self;
  }

  window.featureFlagsService = featureFlagsService;
})();
